<template>
  <div class="d-flex flex-column px-5 py-3">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'NodeContent'
  }
</script>

<style scoped>

</style>
